const map = require('lodash/fp/map');
const memoizer = require('../request-handler/utils/memoizer');


function parseJson(result) {
  return JSON.stringify(result);
}


function parseArticleSlug(article) {

  let oResult = {
    title: "",
    image: {
      uri : ""
    },
    desc: "",
    date:"",
    author: "",
    attachments : []
  }


  oResult.title = article.title != null ?  article.title : "" ;
  oResult.author  = article.authorName != null ?  article.authorName : '';
  oResult.image.uri = article.themeImage != null ? article.themeImage : '';
  oResult.desc = article.themeText != null ? article.themeText : "" ;
  oResult.date = (article.publishedDate !== null && article.publishedDate !=="") ? article.publishedDate : " ";
  oResult.attachments = article.attachmentList != null ? article.attachmentList  : [];
  oResult.status = article.status !=null ? article.status : '';
  oResult.assetColorcode = article.assetColorcode !=null ? article.assetColorcode:'';
  oResult.ideaType = article.ideaType != null ? article.ideaType  : '';
  oResult.assetType = article.assetType != null ? article.assetType  : '';
  oResult.errorMsg =  article.errorMsg !=null ? article.errorMsg : '';

  return oResult;

}


function serviceFactory({ api }) {

  const getInvestmentsFilterData = memoizer()(({ base64Assets,base64Actions,metaData }) =>
  api.getInvestmentFilterapi( base64Assets,base64Actions,metaData)
    .then(parseJson));

  const getAssetNames = memoizer()(({ metaData }) =>
    api.getAssetNames(metaData)
      .then(parseJson));

  const getArticle = memoizer()(({ articleId, metaData }) =>
    api.getArticle(articleId,metaData)
      .then(parseArticleSlug)
      .then(parseJson));

  const searchInvestmentIdeas = memoizer()(({text, metaData }) =>
    api.searchInvestmentIdeas(text, metaData)
      .then(parseJson));

  return {
    getAssetNames, getInvestmentsFilterData, getArticle, searchInvestmentIdeas
  };
}

module.exports = serviceFactory;


